import type { FC, ReactNode } from "react";
import { cn } from "../lib/utils";
import { Badge } from "../primitives";

export type NotificationsColor = "gray" | "red";
export type ToolIconProps = {
	icon: ReactNode;
	onClick?: () => void;
	label?: string;
	notifications?: {
		count: number;
		color?: NotificationsColor;
	};
	className?: string;
};

export const ToolIcon: FC<ToolIconProps> = ({ icon, onClick, label, notifications, className }) => {
	const showNotifications = notifications && notifications.count > 0;

	return (
		<button
			title={label}
			aria-label={label}
			className={cn(
				"relative h-[19px] w-[19px] flex items-center justify-center cursor-pointer text-gray-400 hover:text-gray-800",
				showNotifications && "mr-2",
				className,
			)}
			onClick={onClick}
		>
			{icon}
			{notifications && (
				<Badge
					count={notifications.count}
					size="sm"
					testId="notification-badge"
					tone={notifications.color === "red" ? "danger" : "brand"}
					className="top-[3px]"
				/>
			)}
		</button>
	);
};
